<template>
    <div id="content">
        <loader></loader>
        <div class="top">
            <div class="header">
                <h1>Calcul des primes</h1>
                <div class="pageOptions">
                    <Btn text="Enregistrer" ico="valide" @click="save" v-if="$store.getters.hasPerm('prime:edit')"></Btn>
                    <Btn ico="times" color="red" @click="cancel" v-if="$store.getters.hasPerm('prime:edit')"></Btn>
                    <Btn ico="times" color="red" @click="close" v-if="!$store.getters.hasPerm('prime:edit')"></Btn>
                </div>
            </div>
        </div>
        <form class="" action="" method="post" autocomplete="off" id="prime">
            <input autocomplete="off" name="hidden" type="text" style="display:none;"/>
            <div class="superLine">
                <div class="line">
                    <div class="medium">
                        <label for="month">Mois</label>
                        <select name="" id="month" v-model="month" :disabled="$store.getters.hasPerm('prime:show')">
                            <option value="1">Janvier</option>
                            <option value="2">Février</option>
                            <option value="3">Mars</option>
                            <option value="4">Avril</option>
                            <option value="5">Mai</option>
                            <option value="6">Juin</option>
                            <option value="7">Juillet</option>
                            <option value="8">Aout</option>
                            <option value="9">Septembre</option>
                            <option value="10">Octobre</option>
                            <option value="11">Novembre</option>
                            <option value="12">Décembre</option>
                        </select>
                    </div>
                    <div class="medium">
                        <label for="year">Année</label>
                        <input type="text" id="year" v-model="year" :readonly="$store.getters.hasPerm('prime:show')">
                    </div>
                </div>
            </div>
            <table>
                <tr>
                    <td><label for="tempsPresenceContrat">Temps de présence contrat de travail</label></td>
                    <td><div><input type="text" id="tempsPresenceContrat" :value="timestampToString(data.tempsPresenceContrat)" @change="change($event,'tempsPresenceContrat')" :class="{error:!valideTimestamp('tempsPresenceContrat')}" :readonly="$store.getters.hasPerm('prime:show')"></div></td>
                </tr>
                <tr>
                    <td><label for="heureAbsence">Heure absence</label></td>
                    <td><div><input type="text" :value="timestampToString(data.heureAbsence)" id="heureAbsence" @change="change($event,'heureAbsence')" :class="{error:!valideTimestamp('heureAbsence')}" :readonly="$store.getters.hasPerm('prime:show')"></div></td>
                </tr>
                <tr>
                    <td><label for="heureSupplementaire">Heure supplémentaire</label></td>
                    <td><div><input type="text" class="time" :value="timestampToString(data.heureSupplementaire)" id="heureSupplementaire" @change="change($event,'heureSupplementaire')" :class="{error:!valideTimestamp('heureSupplementaire')}" :readonly="$store.getters.hasPerm('prime:show')"></div></td>
                </tr>
                <tr>
                    <td><label for="tempsPresenceReel">Temps de présence réelle</label></td>
                    <td><div><input type="text" class="time" :value="timestampToString(data.tempsPresenceReel)" id="tempsPresenceReel" readonly :class="{error:!valideTimestamp('tempsPresenceReel')}"></div></td>
                </tr>
                <tr>
                    <td><label for="tauxPresenceReel">Taux de présence réelle</label></td>
                    <td><div><input type="text" class="time" v-model="data.tauxPresenceReel+'%'" id="tauxPresenceReel" readonly></div></td>
                </tr>
                <tr class="border-top">
                    <td><label for="nombreAppleTraites">Nombre d'appels traités</label></td>
                    <td><div><input type="text" id="nombreAppleTraites" v-model="data.nombreAppleTraites" :readonly="$store.getters.hasPerm('prime:show')"></div></td>
                </tr>
                <tr>
                    <td><label for="tempsCommunicationMensuel">Temps de communication mensuel</label></td>
                    <td><div><input type="text" :value="timestampToString(data.tempsCommunicationMensuel)" id="tempsCommunicationMensuel" @change="change($event,'tempsCommunicationMensuel')" :class="{error:!valideTimestamp('tempsCommunicationMensuel')}" :readonly="$store.getters.hasPerm('prime:show')"></div></td>
                </tr>
                <tr>
                    <td><label for="tempsMoyenConversationMenseul">Temps moyen de conversation mensuel</label></td>
                    <td><div><input type="text" class="time" :value="timestampToString(data.tempsMoyenConversationMenseul)" id="tempsMoyenConversationMenseul" readonly></div></td>
                </tr>
                <tr>
                    <td><label for="tempsAdditionnelAutreActivites">Temps additionnel pour autres activités</label></td>
                    <td><div><input type="text" class="time" :value="timestampToString(data.tempsAdditionnelAutreActivites)" id="tempsAdditionnelAutreActivites" @change="change($event,'tempsAdditionnelAutreActivites')" :class="{error:!valideTimestamp('tempsAdditionnelAutreActivites')}" :readonly="$store.getters.hasPerm('prime:show')"></div></td>
                </tr>
                <tr>
                    <td><label for="tempsAppelSortants">Temps appels sortants</label></td>
                    <td><div><input type="text" class="time" :value="timestampToString(data.tempsAppelSortants)" id="tempsAppelSortants" @change="change($event,'tempsAppelSortants')" :class="{error:!valideTimestamp('tempsAppelSortants')}" :readonly="$store.getters.hasPerm('prime:show')"></div></td>
                </tr>
                <tr>
                    <td><label for="tempsTravailCumuleMois">Temps de travail cumulé sur le mois</label></td>
                    <td><div><input type="text" class="time" :value="timestampToString(data.tempsTravailCumuleMois)" id="tempsTravailCumuleMois" readonly :class="{error:!valideTimestamp('tempsTravailCumuleMois')}"></div></td>
                </tr>
                <tr>
                    <td><label for="tauxOccupation">Taux d'occupation</label></td>
                    <td><div><input type="text" class="time" v-model="data.tauxOccupation+'%'" id="tauxOccupation" readonly></div></td>
                </tr>
                <tr class="border-top">
                    <td><label for="nombreAppelRadio">Nombre d'appels Radio Conventionnelle</label></td>
                    <td><div><input type="text" id="nombreAppelRadio" v-model="data.nombreAppelRadio" :readonly="$store.getters.hasPerm('prime:show')"></div></td>
                </tr>
                <tr>
                    <td><label for="tempsMoyenRadio">Temps moyen Radio Conventionnelle *</label></td>
                    <td><div><input type="text" :value="timestampToString(data.tempsMoyenRadio)" id="tempsMoyenRadio" @change="change($event,'tempsMoyenRadio')" :class="{error:!valideTimestamp('tempsMoyenRadio')}" :readonly="$store.getters.hasPerm('prime:show')"></div></td>
                </tr>
                <tr>
                    <td><label for="tauxAppelRadio">Taux d'appels Radio Conventionnelle</label></td>
                    <td><div><input type="text" class="time" v-model="data.tauxAppelRadio+'%'" id="tauxAppelRadio" readonly></div></td>
                </tr>
                <tr class="border-top">
                    <td><label for="nombreAppelScanner">Nombre d'appels Imagerie en coupe (SCANNER-IRM)</label></td>
                    <td><div><input type="text" id="nombreAppelScanner" v-model="data.nombreAppelScanner" :readonly="$store.getters.hasPerm('prime:show')"></div></td>
                </tr>
                <tr>
                    <td><label for="tempsMoyenScanner">Temps moyen Imagerie en coupe (SCANNER-IRM) *</label></td>
                    <td><div><input type="text" :value="timestampToString(data.tempsMoyenScanner)" id="tempsMoyenScanner" @change="change($event,'tempsMoyenScanner')" :class="{error:!valideTimestamp('tempsMoyenScanner')}" :readonly="$store.getters.hasPerm('prime:show')"></div></td>
                </tr>
                <tr>
                    <td><label for="tauxAppelScanner">Taux d'appels Imagerie en coupe (SCANNER-IRM)</label></td>
                    <td><div><input type="text" class="time" v-model="data.tauxAppelScanner+'%'" id="tauxAppelScanner" readonly></div></td>
                </tr>
                <tr class="border-top">
                    <td><label>Prime Radio Conventionnelle</label></td>
                    <td>
                        <div><label for="prime_rc_base">Base</label><input type="text" :value="prime_rc_base+' €'" id="prime_rc_base" readonly></div>
                        <div><label for="prime_rc_eligible">Eligible</label><input type="text" :value="prime_rc_eligible+' €'" id="prime_rc_eligible" readonly></div>
                    </td>
                </tr>
                <tr class="border-top">
                    <td><label>Prime Imagerie en coupe (SCANNER-IRM)</label></td>
                    <td>
                        <div><label for="prime_scan_base">Base</label><input type="text" :value="prime_scan_base+' €'" id="prime_scan_base" readonly></div>
                        <div><label for="prime_scan_eligible">Eligible</label><input type="text" :value="prime_scan_eligible+' €'" id="prime_scan_eligible" readonly></div>
                    </td>
                </tr>
                <tr class="border-top">
                    <td><label for="prime_exceptionnelle">Prime exceptionnelle d'engagement</label></td>
                    <td><div><input type="text" class="time" v-model="prime_exceptionnelle" id="prime_exceptionnelle" :readonly="$store.getters.hasPerm('prime:show')"></div></td>
                </tr>
                <tr>
                    <td><label for="prime_total">Total</label></td>
                    <td><div><input type="text" :value="prime_total+' €'" id="prime_total" readonly></div></td>
                </tr>
            </table>
        </form>
    </div>
</template>

<script>
import Loader from "@/components/Loader";
import Btn from "@/components/Btn";
import moment from 'moment';
import axios from "axios";
import tools from "@/config";

export default {
    name: "Prime",
    components: {Loader, Btn},
    data() {
        return {
            id:0,
            user_id:0,
            data: {
                tempsPresenceContrat: 546000,
                heureAbsence: 0,
                heureSupplementaire: 0,
                tempsPresenceReel: 0,
                tauxPresenceReel: 0,
                nombreAppleTraites: 0,
                tempsCommunicationMensuel: 0,
                tempsMoyenConversationMenseul: 0,
                tempsAdditionnelAutreActivites: 0,
                tempsAppelSortants: 0,
                tempsTravailCumuleMois: 0,
                tauxOccupation: 0,
                nombreAppelRadio: 0,
                tempsMoyenRadio: 0,
                tauxAppelRadio: 0,
                nombreAppelScanner: 0,
                tempsMoyenScanner: 0,
                tauxAppelScanner: 0,
            },
            month: moment().month(),
            year: moment().year(),
            prime_rc_base: 0,
            prime_scan_base: 0,
            prime_rc_eligible: 0,
            prime_scan_eligible: 0,
            prime_total: 0,
            prime_exceptionnelle: 0,
    
            bases:[],
        }
    },
    methods: {
        async load(){
            
            if(!this.id) return;
    
            tools.loader(true);
    
            try{
                let response = await axios.get(tools.api("user/"+this.user_id+"/prime/"+this.id),tools.headerGET())
                response = response.data[0];
                console.log(response)
                this.data = JSON.parse(response.calcul);
                this.month = response.month
                this.year = response.year;
                this.prime_rc_base = response.prime_rc_base;
                this.prime_scan_base = response.prime_scan_base;
                this.prime_rc_eligible = response.prime_rc_eligible;
                this.prime_scan_eligible = response.prime_scan_eligible;
                this.prime_total = response.prime_total;
                this.prime_exceptionnelle = response.prime_exceptionnelle;
                this.user_id = response.user_id;
            }catch (e) {
    
                console.log(e)
                return false;
            }
    
            return true;
        },async loadUser() {
        
            if (!this.user_id) {
                return;
            }
        
            try {
                let response = await axios.get(tools.api("user/" + this.user_id), tools.headerGET())
                this.user = response.data;
            }catch (e) {
                
            }
        
        },
        save(){
            axios.post(tools.api("user/"+this.user_id+"/prime"), tools.toPOST({
                id:this.id,
                month:this.month,
                year:this.year,
                calcul : JSON.stringify(this.data),
                prime_rc_base: this.prime_rc_base,
                prime_scan_base: this.prime_scan_base,
                prime_rc_eligible: this.prime_rc_eligible,
                prime_scan_eligible: this.prime_scan_eligible,
                prime_total: this.prime_total,
                prime_exceptionnelle: this.prime_exceptionnelle,
            }), tools.headerPOST())
                .then((response) => {
                    this.$router.push("/user/"+this.user_id+"/primes")
                })
        },
        cancel(){
            tools.popup("confirm", {
                title: "Confirmer",
                message: "Voulez-vous vraiment annuler les modifications ?",
                success: () => {
                    this.$router.push("/user/"+this.user_id+"/primes")
                }
            })
        },
        close(){
            return this.$router.back();
        },
        change($event,data){
            let value = $event.target.value
            this.data[data] = this.stringToTimestamp(value);
            
            this.calculPrime()
        },
        calculPrime(){
            this.data.tempsPresenceReel = this.data.tempsPresenceContrat - this.data.heureAbsence + this.data.heureSupplementaire
            this.data.tauxPresenceReel = parseInt(this.data.tempsPresenceReel / this.data.tempsPresenceContrat * 100)
            this.data.tempsMoyenConversationMenseul = parseInt(this.data.tempsCommunicationMensuel / this.data.nombreAppleTraites)
            this.data.tempsTravailCumuleMois = this.data.tempsAppelSortants + this.data.tempsAdditionnelAutreActivites + this.data.tempsCommunicationMensuel
            this.data.tauxOccupation = Math.round(this.data.tempsTravailCumuleMois / this.data.tempsPresenceReel * 100)
            this.data.tauxAppelRadio = Math.round(this.data.nombreAppelRadio / this.data.nombreAppleTraites * 100)
            this.data.tauxAppelScanner = Math.round(this.data.nombreAppelScanner / this.data.nombreAppleTraites * 100)
    
            if(isNaN(this.data.tauxPresenceReel)) this.data.tauxPresenceReel = 0
            if(isNaN(this.data.tempsMoyenConversationMenseul)) this.data.tempsMoyenConversationMenseul = 0
            if(isNaN(this.data.tauxOccupation)) this.data.tauxOccupation = 0
            if(isNaN(this.data.tauxAppelRadio)) this.data.tauxAppelRadio = 0
            if(isNaN(this.data.tauxAppelScanner)) this.data.tauxAppelScanner = 0
            
            if(this.bases.length <= 0) return;
            
            let bases = [{base_radio_conv:9999999,base_imagerie_coupe:9999999,prime:0} ,...this.bases,{base_radio_conv:0,base_imagerie_coupe:0,prime:this.bases[this.bases.length - 1].prime}]
            console.log(bases)
            if(bases.length <= 2) return;
            
            for(let i = 0; i < bases.length - 1; i++)
            {
                if(this.data.tempsMoyenRadio > bases[i+1].base_radio_conv && this.data.tempsMoyenRadio <= bases[i].base_radio_conv){
                    this.prime_rc_base = bases[i+1].prime;
                }
                
                if(this.data.tempsMoyenScanner > bases[i+1].base_imagerie_coupe && this.data.tempsMoyenScanner <= bases[i].base_imagerie_coupe){
                    this.prime_scan_base = bases[i+1].prime;
                }
            }
            this.prime_rc_eligible = (this.data.tauxPresenceReel/100) * (this.data.tauxAppelRadio/100) * this.prime_rc_base
            this.prime_scan_eligible = (this.data.tauxPresenceReel/100) * (this.data.tauxAppelScanner/100) * this.prime_scan_base
            this.prime_total = this.prime_rc_eligible + this.prime_scan_eligible + parseFloat(this.prime_exceptionnelle)
        },
        stringToTimestamp(string){
            let data = string.split(":");
            if(string === "") return 0
            if(data[0] === "") data[0] = "00"
            if(data[1] === "") data[1] = "00"
            if(data[2] === "") data[2] = "00"
            if(data.length === 0) return 0
            if(data.length === 1) data.push("00:00")
            if(data.length === 2) data.push("00")
            if(data.length > 3) data.splice(3,data.length - 3)
            
            let h = parseInt(data[0] || 0) * 3600
            let m = parseInt(data[1] || 0) * 60
            let s = parseInt(data[2] || 0)
            
            return h+m+s;
        },
        timestampToString(time){
            let start = moment(0);
            let date = moment(time*1000);
            let diff = moment.duration(date.diff(start))
            
            let h = parseInt(diff.asHours());
            h = h < 10 ? "0"+h : h;
            let m = parseInt(diff.minutes());
            m = m < 10 ? "0"+m : m;
            let s = parseInt(diff.seconds());
            s = s < 10 ? "0"+s : s;
            
            return h+":"+m+":"+s
            
        },
        valideTimestamp(data){
            return this.timestampToString(this.data[data]).split(":").length === 3
        }
    },
    watch:{
        prime_exceptionnelle(){
    
            if(isNaN(parseFloat(this.prime_exceptionnelle))){
                this.prime_exceptionnelle = 0
            }
            
            console.log(this.prime_exceptionnelle)
    
            this.calculPrime()
        }
    },
    async mounted() {
        this.user_id = this.$route.params.user_id;
        this.id = this.$route.params.id;
    
        tools.loader(true);
    
        let bases = await axios.get(tools.api("option/base"),tools.headerGET())
        this.bases = JSON.parse(bases.data.value);
    
        await this.load();
        await this.loadUser();
    
        this.calculPrime();
    
        tools.loader(false);
    }
}
</script>